import React, { FC, MutableRefObject, useState } from 'react';
import { obj } from 'src/common/models/common-types';
import CustomDataGridActionsBar, { DataGridAction } from './CustomDataGridActionsBar';
import { Box, SxProps } from '@mui/material';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';
import { DataGridPro, GridApi, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';

interface ActionsBarOptions {
    actions: DataGridAction[];
    styles?: any;
}

interface CustomDataGridProps {
    rows: obj<any>[];
    columns: GridColDef<obj<any>>[];
    apiRef: MutableRefObject<GridApi>;
    dataGridProps?: Partial<DataGridProProps>;
    actionsBar?: boolean;
    actionsBarOptions?: ActionsBarOptions;
    styles?: SxProps;
    autoHeight?: boolean;
}

const CustomDataGrid: FC<CustomDataGridProps> = ({
    rows,
    columns,
    apiRef,
    actionsBar,
    dataGridProps,
    styles,
    actionsBarOptions,
    autoHeight,
}) => {
    const [selectedItems, setSelectedItems] = useState([]);

    return (
        <Box sx={{ position: 'relative' }}>
            <DataGridPro
                autoHeight={autoHeight}
                columns={columns}
                sortingOrder={['desc', 'asc']}
                rows={rows}
                apiRef={apiRef}
                checkboxSelection
                onRowSelectionModelChange={(rowSelectionModel) => {
                    actionsBar && setSelectedItems(rows.filter((row) => rowSelectionModel.includes(row.id)));
                }}
                slots={{ baseCheckbox: CustomCheckbox }}
                sx={{
                    '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within': {
                        outline: 'none',
                    },

                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': {
                        outline: 'none',
                    },
                    '& .MuiDataGrid-virtualScrollerContent': {
                        height: '350px !important',
                    },
                    ...styles,
                }}
                {...dataGridProps}
            />
            {actionsBar && apiRef.current?.state && (
                <CustomDataGridActionsBar
                    selectedItemIds={selectedItems}
                    onClearSelection={() => apiRef.current.setRowSelectionModel([])}
                    {...actionsBarOptions}
                />
            )}
        </Box>
    );
};

export default CustomDataGrid;
